
import Video from "../../components/video/Video.vue";
import { WXApi } from "../../wx/WXApi";
import { Vue, Options } from "vue-class-component";

@Options({
  components: {
    Video
  }
})
export default class LiveVideo extends Vue {
  private isShowShared = false;
  private isShowPoster = false;
  private isBounceUp = true;
  mounted() {
    window.document.title = "CHERRY 2020 全球线上发布会";
    this.defultShare();

    const div = document.getElementById("live_bg") as HTMLDivElement;
    div.addEventListener(
      "scroll",
      () => {
        if (div.scrollTop + window.innerHeight - 20 > window.innerHeight) {
          this.isBounceUp = false;
        } else {
          this.isBounceUp = true;
        }
      },
      false
    );
  }

  defultShare() {
    WXApi.wxShareData(
      this.shareContent(),
      () => {
        console.log();
      },
      () => {
        console.log();
      }
    );
  }
  shareContent() {
    const opstion = {
      title: "[CHERRY∞FUTURE] CHERRY 2020 全球线上发布会 11月1日 20:00",
      link: "https://user.cherry.cn",
      imgUrl: "https://t.irocks.cn/cherry/use/other/11.1_share.png",
      dec: "时隔2年，CHERRY发布会回归。两年间，我们做了什么？"
    };
    return opstion;
  }
  share() {
    WXApi.wxShareData(
      this.shareContent(),
      () => {
        this.isShowShared = true;
      },
      () => {
        this.isShowShared = false;
      }
    );
  }
  poster() {
    this.isShowPoster = true;
  }
  closeShared() {
    this.isShowShared = false;
  }
  closePoster() {
    this.isShowPoster = false;
  }
}
